module.exports = __webpack_public_path__ + "img/gaosu-min.a00e82df.jpg";